"use client";

import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { ArrowRight, Sparkles } from "lucide-react";
import { gradient } from "./utils/constants";
import { handleNavClick } from "./hero";

export function CTA() {
  return (
    <section className="py-20 bg-linear-to-br from-blue-800 via-slate-900 to-purple-800 relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0">
        <div className="absolute top-20 left-20 w-72 h-72 bg-purple-500/20 rounded-full blur-3xl animate-pulse" />
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-pink-500/20 rounded-full blur-3xl animate-pulse" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center"
        >
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2 text-white/80 text-sm mb-6">
            <Sparkles className="w-4 h-4" />
            Ready to Transform Your Images?
          </div>

          <h2 className="text-4xl lg:text-6xl font-bold text-white leading-tight">
            Start Your Project{" "}
            {/* <span className={` ${gradient} text-transparent bg-clip-text`}> */}
            Today
            {/* </span> */}
          </h2>

          <p className="text-xl text-white/80 mb-8 max-w-2xl mx-auto leading-relaxed">
            We're new, and that means you get our absolute best effort on every
            project. Professional results, honest communication, and fast
            turnaround — guaranteed.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button
              size="lg"
              onClick={() => handleNavClick("/#contact")}
              className={`${gradient} text-white px-8 py-4 text-lg font-semibold cursor-pointer`}
            >
              Get Free Quote Now
              <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
          </div>

          {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.1 }}
              viewport={{ once: true }}
              className="text-center"
            >
              <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-3">
                <Clock className="w-6 h-6 text-white" />
              </div>
              <h3 className="text-white font-semibold mb-2">
                24-Hour Turnaround
              </h3>
              <p className="text-white/70 text-sm">
                Fast delivery without compromising quality
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              viewport={{ once: true }}
              className="text-center"
            >
              <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-3">
                <Shield className="w-6 h-6 text-white" />
              </div>
              <h3 className="text-white font-semibold mb-2">
                100% Satisfaction
              </h3>
              <p className="text-white/70 text-sm">
                Unlimited revisions until you&apos;re happy
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.3 }}
              viewport={{ once: true }}
              className="text-center"
            >
              <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-3">
                <Sparkles className="w-6 h-6 text-white" />
              </div>
              <h3 className="text-white font-semibold mb-2">
                Professional Quality
              </h3>
              <p className="text-white/70 text-sm">
                Expert editors with years of experience
              </p>
            </motion.div>
          </div> */}
        </motion.div>
      </div>
    </section>
  );
}
